<style scoped>
  .label{
    position: relative;
    float: left;
    display: inline-block;
    vertical-align: top;
    width: 120px;
    padding-right: 6px;
    text-align: right;
    color: #888;
  }
  .label:before{
    content: ':';
    position: absolute;
    top: 0;
    right: 0;
  }
  .value{
    padding-left: 125px;
    white-space: normal;
  }
  .user-flow{
    margin-top: 20px;
  }
  .user-flow .value{
    padding-top: 3px;
    padding-left: 130px;
  }
  .line /deep/ .ivu-table-expanded-cell{
    padding: 20px 4px;
  }
</style>
<template>
  <div>
    <h2 class="text-center">
      {{ type_text }}
    </h2>
    <div v-if="expense_group.id">
      <div class="line">
        <div class="label">
          {{ type_text }}编号
        </div>
        <div class="value">
          {{ expense_group.uid }}
          <span
            v-if="expense_group.del"
            :class="{'color-error': expense_group.del}"
          >[<Icon
            type="trash-a"
            size="13"
          /> 已废弃]</span>
          <span
            v-if="expense_group.is_refund"
            :class="{'color-error': expense_group.is_refund}"
          >[银行已退款]</span>
          <span
            v-if="should_set_bank"
            :class="{'color-error': should_set_bank}"
          >[未设置付款银行]</span>
          <span v-if="expense_group.advance_id">[冲预支]</span>
        </div>
      </div>
      <div class="line">
        <div class="label">
          名称
        </div>
        <div class="value">
          {{ expense_group.name }}
        </div>
      </div>
      <div class="line">
        <div class="label">
          申请人
        </div>
        <div class="value">
          {{ expense_group.apply_user }}
        </div>
      </div>
      <div class="line">
        <div class="label">
          公司 | 团队
        </div>
        <div class="value">
          {{ company_team }}
        </div>
      </div>
      <div class="line">
        <div class="label">
          总金额
        </div>
        <div class="value">
          {{ $util.formatPrice(expense_group.total_price) }}
        </div>
      </div>
      <div
        v-if="expense_group.purpose"
        class="line"
      >
        <div class="label">
          用途
        </div>
        <div class="value">
          {{ expense_group.purpose || '无' }}
        </div>
      </div>
      <div class="line">
        <div class="label">
          备注
        </div>
        <div class="value">
          <span
            v-if="expense_group.desc"
            v-html="expense_group.desc"
          />
          <span v-else>无</span>
        </div>
      </div>
      <div class="hr" />
      <div
        v-if="expense_group.receipt"
        class="line"
      >
        <div class="label">
          银行回单
        </div>
        <a
          class="value"
          :href="$util.receiptUrl(expense_group.receipt.filename)"
          target="_blank"
          style="display: block"
        >
          下载
        </a>
      </div>
      <div class="line">
        <div class="label">
          付款币种
        </div>
        <div class="value">
          {{ getCurrencyName(expense_group.currency) }}
        </div>
      </div>
      <div class="line">
        <div class="label">
          对方银行
        </div>
        <div class="value">
          {{ expense_group.payee_bank }}
        </div>
      </div>
      <div class="line">
        <div class="label">
          账户名
        </div>
        <div class="value">
          {{ expense_group.payee_account_name }}
        </div>
      </div>
      <div class="line">
        <div class="label">
          卡号
        </div>
        <div class="value">
          {{ expense_group.payee_bank_number }}
        </div>
      </div>
      <div class="line">
        <div class="label">
          入账会计期
        </div>
        <div class="value">
          {{ expense_group.verified_at ? this.$util.formatDate(expense_group.verified_at) : '-' }}
        </div>
      </div>
      <div
        v-if="expense_group.expenses && expense_group.expenses.length"
        class="line"
      >
        <Table
          size="small"
          :columns="expense_columns"
          :data="expense_group.expenses"
        />
      </div>
      <div class="hr" />
      <div
        v-if="expense_group.advance.id"
        class="line"
      >
        <div class="line">
          <div class="label">
            关联预支单
          </div>
          <div class="value">
            <ViewerItem
              :model_id="expense_group.advance.id"
              type="ExpenseGroup"
            >
              <span class="link">{{ expense_group.advance.uid }}</span>
            </ViewerItem>
          </div>
          <div class="value">
            {{ expense_group.advance.name }}
          </div>
        </div>
        <div class="line">
          <div class="label">
            用途
          </div>
          <div class="value">
            {{ expense_group.advance.purpose || '-' }}
          </div>
        </div>
        <div class="hr" />
      </div>
      <div
        v-if="expense_group.expense_group"
        class="line"
      >
        <div class="line">
          <div class="label">
            关联报销单
          </div>
          <div class="value">
            <ViewerItem
              :model_id="expense_group.expense_group.id"
              type="ExpenseGroup"
            >
              <span class="link">{{ expense_group.expense_group.uid }}</span>
            </ViewerItem>
          </div>
          <div class="value">
            {{ expense_group.expense_group.name }}
          </div>
        </div>
        <div class="hr" />
      </div>
      <div
        v-if="expense_group.contract.id"
        class="line"
      >
        <div class="line">
          <div class="label">
            关联合同
          </div>
          <div class="value">
            <ViewerItem
              :model_id="expense_group.contract.id"
              type="Contract"
            >
              <span class="link">{{ expense_group.contract.uid }}</span>
            </ViewerItem>
          </div>
          <div class="value">
            {{ expense_group.contract.name }}
          </div>
        </div>
        <div class="line">
          <div class="label">
            申请人
          </div>
          <div class="value">
            {{ expense_group.contract.apply_user }}
          </div>
        </div>
        <div class="line">
          <div class="label">
            对方公司
          </div>
          <div class="value">
            {{ expense_group.contract.payee_company }}
          </div>
        </div>
        <div class="hr" />
      </div>
      <div
        v-if="expense_group.outsource_contract_id"
        class="line"
      >
        <div class="line">
          <div class="label">
            关联兼职外包合同
          </div>
          <div class="value">
            <ViewerItem
              :model_id="expense_group.outsource_contract.id"
              type="OutsourceContract"
            >
              <span class="link">{{ expense_group.outsource_contract.uid }}</span>
            </ViewerItem>
          </div>
          <div class="value">
            {{ expense_group.outsource_contract.account }}
          </div>
        </div>
        <div class="line">
          <div class="label">
            申请人
          </div>
          <div class="value">
            {{ expense_group.outsource_contract.apply_user }}
          </div>
        </div>
        <div class="hr" />
      </div>
      <div class="line">
        <div class="label">
          附件
        </div>
        <div
          v-if="expense_group.bfiles.length"
          class="value"
        >
          <Attachments :files="expense_group.bfiles" />
        </div>
        <div
          v-else
          class="value"
        >
          无
        </div>
      </div>
      <div
        v-if="expense_group.user_flow"
        class="line user-flow"
      >
        <div class="label">
          流程状态
        </div>
        <div class="value">
          <UserFlow :user_flow="expense_group.user_flow" />
        </div>
      </div>
    </div>
    <div
      v-else
      class="text-center"
    >
      <Spin
        size="large"
        fix
      />
    </div>
  </div>
</template>
<script>
  import ExpenseUtil from '../../../../libs/expense_util';
  import ExpenseGroupUtil from '../../../expense_group/libs/util';
  import ExpenseExpand from '../../../fin/components/expense_expand';
  import ViewerItem from '../item';
  import Attachments from '../../../components/file/attachments';
  import {mapGetters} from "vuex";
  export default {
    components: { ExpenseExpand, ViewerItem, Attachments },
    props: {
      model_id: {
        type: Number
      }
    },
    data() {
      return {
        expense_group: {}
      }
    },
    computed: {
      type_text() {
        return ExpenseUtil.getPaymentType(this.expense_group.payment_type);
      },
      is_base_currency() {
        const company = this.companies_hash[this.expense_group.company_id];
        if (!company) {
          return true;
        }
        return company.base_currency === this.expense_group.currency;
      },
      base_currency_name() {
        const company = this.companies_hash[this.expense_group.company_id];
        if (!company) {
          return '未选择公司';
        } else {
          if (!company.base_currency) {
            return '未设置本位币';
          }
        }
        return ExpenseUtil.getCurrencyName(company.base_currency);
      },
      currency_name() {
        const currency = this.expense_group.currency;
        if (!currency) {
          return '请选择币别';
        } else {
          return ExpenseUtil.getCurrencyName(currency);
        }
      },
      expense_columns() {
        let columns = [
          {
            title: '展开',
            type: 'expand',
            align: 'center',
            width: 50,
            render: (h, params) => {
              return h(ExpenseExpand, {
                props: {
                  expense: params.row
                }
              })
            }
          },
          {
            title: '项目描述',
            align: 'center',
            key: 'name'
          }
        ];
        columns = columns.concat([
          {
            title: '金额',
            align: 'right',
            width: 100,
            key: 'price',
            render: (h, params) => {
              return h('div', {
                'class': {
                  'text-right': true
                },
                style: {
                  'white-space': 'nowrap'
                }
              }, this.$util.formatPrice(params.row.price));
            }
          },
          {
            title: '付款手续费',
            align: 'right',
            width: 100,
            key: 'service_fee',
            render: (h, params) => {
              return h('div', {
                'class': {
                  'text-right': true
                },
                style: {
                  'white-space': 'nowrap'
                }
              }, this.$util.formatPrice(params.row.service_fee));
            }
          },
          {
            title: '备注',
            align: 'center',
            key: 'desc',
            render: (h, params) => {
              const row = params.row;
              if (row.desc) {
                return h('div', row.desc);
              } else {
                return h('div', '-');
              }
            }
          }
        ]);
        return columns;
      },
      ...mapGetters({
        companies: 'async/companies',
        companies_hash: 'async/companies_hash',
        teams: 'async/root_teams',
        teams_hash: 'async/root_teams_hash',
      }),
      company() {
        const company = this.companies_hash[this.expense_group.company_id];
        return company ? company.short_name : '-';
      },
      team() {
        const team = this.teams_hash[this.expense_group.team_id];
        return team ? team.name : '-';
      },
      company_team() {
        return `${this.company} | ${this.team}`;
      },
      is_finish() {
        return this.expense_group.status === 9 || (this.expense_group.user_flow && this.expense_group.user_flow.is_finish)
      },
      should_set_bank() {
        return this.is_finish && !this.expense_group.expense_payment_bank_id && ![5, 6, 7].includes(this.expense_group.payment_type);
      },
    },
    created() {
      this.getExpenseGroup();
    },
    mounted() {
      //
    },
    methods: {
      getExpenseGroup() {
        const _this = this
        ExpenseGroupUtil.getDetail(this.model_id).then((data) => {
          _this.expense_group = data.expense_group;
        }).catch((e) => {
          _this.$Model.error({title: '提示', content: e.message});
        });
      },
      getCurrencyName(currency_value) {
        return ExpenseUtil.getCurrencyName(currency_value);
      },
      getCurrencyLabel(currency_value) {
        return ExpenseUtil.getCurrencyLabel(currency_value);
      },
      getCurrencySymbol(currency_value) {
        return ExpenseUtil.getCurrencySymbol(currency_value);
      },
    }
  }
</script>
